import { i18n, setI18nLanguage } from '@/lang/lang'

export default (to, from, next, injection) => {
  const routeLang = to?.params?.lang || from?.params?.lang
  const langExists = routeLang && i18n.messages.hasOwnProperty(routeLang)
  const lang = langExists ? routeLang : i18n.locale
  if (langExists) setI18nLanguage(lang)
  next()
}
